// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tables-container {
  display: flex;
  flex-direction: row; /* Side-by-side layout */
  justify-content: center; /* Center the tables horizontally */
  align-items: flex-start; /* Align items to the top */
  gap: 50px; /* Adjust the space between tables */
  background-color: black; /* Background color of the container */
  margin-right: 0px;
  flex-wrap: wrap; /* Allows wrapping on smaller screens */
}

.table {
  width: 100%;
  max-width: 600px; /* Adjust the width of the tables */
  color: white; /* Default text color for text in table */
}

.table table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #FFFFFF; /* Border for the table */
  overflow-x: auto; /* Add horizontal scroll on small screens */
}

.table caption {
  font-weight: bold; /* Make caption text bold */
  font-size: 16px; /* Font size for captions */
  margin-bottom: 8px; /* Space below the caption */
  color: #333333; /* Caption text color */
}

.table th, .table td {
  border: 1px solid #FFFFFF; /* Border color for table headers and data */
  padding: 8px;
  text-align: center;
  font-size: 14px;
}

.table th {
  background-color: #B18800;
  color: white; /* Text color for headers */
}

.table h2 {
  text-align: center; /* Center-aligns the text of the h2 elements */
}

@media (max-width: 1080px) {
  .tables-container {
    flex-direction: column; /* Stack tables on smaller screens */
    align-items: center;
  }
}


`, "",{"version":3,"sources":["webpack://./src/Components/Tables.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,mCAAmC;EAC5D,uBAAuB,EAAE,2BAA2B;EACpD,SAAS,EAAE,oCAAoC;EAC/C,uBAAuB,EAAE,sCAAsC;EAC/D,iBAAiB;EACjB,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,mCAAmC;EACrD,YAAY,EAAE,yCAAyC;AACzD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB,EAAE,yBAAyB;EACpD,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe,EAAE,2BAA2B;EAC5C,kBAAkB,EAAE,4BAA4B;EAChD,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;EACvE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE;IACE,sBAAsB,EAAE,oCAAoC;IAC5D,mBAAmB;EACrB;AACF","sourcesContent":[".tables-container {\n  display: flex;\n  flex-direction: row; /* Side-by-side layout */\n  justify-content: center; /* Center the tables horizontally */\n  align-items: flex-start; /* Align items to the top */\n  gap: 50px; /* Adjust the space between tables */\n  background-color: black; /* Background color of the container */\n  margin-right: 0px;\n  flex-wrap: wrap; /* Allows wrapping on smaller screens */\n}\n\n.table {\n  width: 100%;\n  max-width: 600px; /* Adjust the width of the tables */\n  color: white; /* Default text color for text in table */\n}\n\n.table table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #FFFFFF; /* Border for the table */\n  overflow-x: auto; /* Add horizontal scroll on small screens */\n}\n\n.table caption {\n  font-weight: bold; /* Make caption text bold */\n  font-size: 16px; /* Font size for captions */\n  margin-bottom: 8px; /* Space below the caption */\n  color: #333333; /* Caption text color */\n}\n\n.table th, .table td {\n  border: 1px solid #FFFFFF; /* Border color for table headers and data */\n  padding: 8px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #B18800;\n  color: white; /* Text color for headers */\n}\n\n.table h2 {\n  text-align: center; /* Center-aligns the text of the h2 elements */\n}\n\n@media (max-width: 1080px) {\n  .tables-container {\n    flex-direction: column; /* Stack tables on smaller screens */\n    align-items: center;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
